<section class="otros-eventos">
    <div class="container">
        <h1 class="section-tit1">{{top_titulo}}</h1>
        <article *ngFor="let evento of eventos; let i = index">
            <div class="blq-cont">
                <neo-span-inner-html *ngIf="i == 0" [contenido]="top_texto"></neo-span-inner-html>

                <h2 class="section-tit2 isotipo-stroke">{{evento.tit}}</h2>
                <neo-span-inner-html [contenido]="evento.txt"></neo-span-inner-html>
                <a class="btn btn-primary" (click)="reservar()" title="">
                    Reserva ahora
                </a>
            </div>
            <div class="blq-img">
                <picture>
                    <img [src]="evento.img1['ruta']" [alt]="evento.img1['alt']"/>
                </picture>
                <picture>
                    <img [src]="evento.img2['ruta']" [alt]="evento.img2['alt']"/>
                </picture>
            </div>
        </article>
    </div>
</section>

<neo-bottom-cta [color]="'negative'"></neo-bottom-cta>
<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>